import content from "app-content";
import SignInButton from "../../../containers/common/SignInButton";
import styles from "./index.css";

const SIGN_IN_TO_SAVE_PROMPT_ID = "signInToSavePrompt";

const SignInToSave = () => (
  <div className={styles.signInToSave}>
    <span className={styles.signInToSaveIcon} />
    <p className={styles.signInToSavePrompt} id={SIGN_IN_TO_SAVE_PROMPT_ID}>
      {content.saved_items_unrecognised_text}
    </p>
    <section aria-labelledby={SIGN_IN_TO_SAVE_PROMPT_ID}>
      <SignInButton className={styles.signInButton} />
    </section>
  </div>
);

export default SignInToSave;
